import styled from 'styled-components';
import { SmartLink } from '../../smart-link/smart-link';
import { addOpacity } from '../../../util/style/add-opacity.util';
import {
  ACTIVE_LIGHTNESS,
  DROPDOWN_ROUTE_WRAPPER_HEIGHT,
  HEADER_VIEW_HEIGHT,
  MENU_ITEM_VERTICAL_MARGIN,
  MENU_ITEM_WIDTH,
  NORMAL_MENU_ITEM_HORIZONTAL_MARGIN,
  PADDING_MENU_CONTENT
} from './consts';
import { lightenColor } from '../../../util/style/lighten-color.util';

interface INormalRouteWrapperProps {
  opacity: number;
  color: string;
  hoverColor: string;
  isMobile?: boolean;
  isSelected: boolean;
}

export const NormalRouteWrapper = styled(SmartLink)`
  position: relative;
  cursor: pointer;
  display:flex;
  outline: none !important;
  text-decoration: none !important;
  align-items: center;
  transition: ease-in 200ms, background-color 300ms, ease-out 200ms;
  width: ${MENU_ITEM_WIDTH}px;
  box-sizing: border-box;
  height: 100%;
  flex: 0 0 ${MENU_ITEM_WIDTH}px;
  color: ${(props: INormalRouteWrapperProps) => props.isSelected ? props.hoverColor : props.color} !important;
  padding: ${MENU_ITEM_VERTICAL_MARGIN}px ${NORMAL_MENU_ITEM_HORIZONTAL_MARGIN}px;
  text-align: center;
  justify-content: center;
  &:hover {
    color: ${(props: INormalRouteWrapperProps) => props.hoverColor} !important;
  }
`;

interface IDropdownRouteWrapperProps {
  backgroundColor: string;
  opacity: number;
  color: string;
  hoverColor: string;
  isSelected: boolean;
}

export const DropdownRouteWrapper = styled(SmartLink)`
  position: relative;
  cursor: pointer;
  display:flex;
  outline: none !important;
  text-decoration: none !important;
  justify-content: flex-start;
  align-items: center;
  transition: ease-in 200ms, background-color 300ms, ease-out 200ms;
  display: flex;
  box-sizing: border-box;
  color: ${(props: IDropdownRouteWrapperProps) => props.isSelected ? props.hoverColor : props.color} !important;
  width: ${MENU_ITEM_WIDTH}px;
  background: ${(props: IDropdownRouteWrapperProps) => props.isSelected ? addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity) : addOpacity(props.backgroundColor, props.opacity)};
  padding: 0 ${PADDING_MENU_CONTENT}px;
  height: ${DROPDOWN_ROUTE_WRAPPER_HEIGHT}px;
  &:hover {
    background: ${(props: IDropdownRouteWrapperProps) => addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity)};
    color: ${(props: IDropdownRouteWrapperProps) => props.hoverColor} !important;
  }
`;

export const MobileRouteWrapper = styled(SmartLink)`
  position: relative;
  cursor: pointer;
  display:flex;
  outline: none !important;
  text-decoration: none !important;
  justify-content: flex-start;
  align-items: center;
  transition: ease-in 200ms, background-color 300ms, ease-out 200ms;
  color: ${(props: IDropdownRouteWrapperProps) => props.isSelected ? props.hoverColor : props.color} !important;
  background: ${(props: IDropdownRouteWrapperProps) => props.isSelected ? addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity) : addOpacity(props.backgroundColor, props.opacity)};
  padding: 0 ${PADDING_MENU_CONTENT}px;
  height: ${DROPDOWN_ROUTE_WRAPPER_HEIGHT}px;
  &:hover {
    background: ${(props: IDropdownRouteWrapperProps) => addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity)};
    color: ${(props: IDropdownRouteWrapperProps) => props.hoverColor} !important;
  }
  box-sizing: border-box;
  padding-right: 20px !important;
  width: 100vw !important;
`;

interface IMenuIconContainerProps {
  backgroundColor: string;
  opacity: number;
  isSelected: boolean;
  color: string;
  hoverColor: string;
}

export const MenuIconContainer = styled.div`
  position: relative;
  padding: ${PADDING_MENU_CONTENT}px;
  background: ${(props: IMenuIconContainerProps) => props.isSelected ? addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity) : addOpacity(props.backgroundColor, props.opacity)};
  width: 60px;
  height: ${HEADER_VIEW_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  color: ${(props: IMenuIconContainerProps) => props.color};
  transition: ease-in 200ms, background 300ms, ease-out 200ms;
  &:hover {
    color: ${(props: IMenuIconContainerProps) => props.hoverColor};
    background: ${(props: IMenuIconContainerProps) => addOpacity(lightenColor(props.backgroundColor, ACTIVE_LIGHTNESS), props.opacity)};
  }
`;
